import React, { useEffect } from 'react';

import { Box, Button, Divider, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ShowErrors } from 'common/components';
import { ReactHookFormInput } from 'common/components/form';
import yupResolver from 'common/utils/yupResolver';

import * as actions from '../actions';
import * as selectors from '../selectors';
import validate from '../validateConfig';

import AmountFields from './AmountFields';
import TaxField from './TaxField';

const CoverageConfigForm = ({
    errors,
    filterData,
    initialValues,
    isSaving,
    save,
    selectedCoverage,
    setSelectedCoverage,
}) => {
    const { t } = useTranslation();
    const { control, handleSubmit, reset } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    const handleOnClickSave = (values) =>
        save(
            filterData,
            { ...values, insurance_product: selectedCoverage.id },
            setSelectedCoverage,
        );

    useEffect(() => reset(initialValues), [initialValues]);

    return (
        <Stack component="form" onSubmit={handleSubmit(handleOnClickSave)}>
            <ReactHookFormInput
                control={control}
                disabled={isSaving}
                label={t('Description')}
                name="description"
            />

            <AmountFields control={control} />

            <ReactHookFormInput
                append="%"
                control={control}
                name="annual_increase"
                label={t('Annual increase')}
                onlyNumbers={true}
                type="text"
            />

            <TaxField control={control} />

            <ShowErrors errors={errors} />

            <Divider sx={{ mx: (theme) => `${theme.spacing(-2)}!important` }} />

            <Box sx={{ textAlign: 'right' }}>
                <Button disabled={isSaving} type="submit">
                    {isSaving ? t('Saving') : t('Save')}
                </Button>
            </Box>
        </Stack>
    );
};

CoverageConfigForm.propTypes = {
    errors: PropTypes.array,
    filterData: PropTypes.object,
    initialValues: PropTypes.object,
    isSaving: PropTypes.bool,
    save: PropTypes.func,
    selectedCoverage: PropTypes.object,
    setSelectedCoverage: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    errors: selectors.getErrorsSaveCoverageConfig,
    initialValues: selectors.getInitialValuesCoverageConfigForm,
    isSaving: selectors.getIsSavingCoverageConfig,
});

const mapDispatchToProps = (dispatch) => ({
    save: (filterData, values, setSelectedCoverage) =>
        dispatch(
            actions.saveCoverageConfig(filterData, values, setSelectedCoverage),
        ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CoverageConfigForm);
